import gql from "graphql-tag";

const CREATE_GUEST_ORDER = gql`
  mutation createGuestOrder($orderData: GuestOrderInput!) {
    createGuestOrder(orderData: $orderData)
  }
`;

export default CREATE_GUEST_ORDER;
